module.exports = __webpack_public_path__ + "img/movil2.5b6bd35e.jpg";